import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Prestazioni',
    [Tab.NewCustomers]: 'Nuovi ristoranti',
    [Tab.CustomerHealth]: 'Salute clienti',
    [Tab.LiveAndInactive]: 'Attivi e inattivi',
    [Tab.BillingHealth]: 'Salute fatturazione',
  },
  labels: {
    sales_manager: 'Responsabile vendite',
  },
  performance_tab: {
    table_columns: {
      name: 'Nome',
      sales_manager: 'Responsabile vendite',
      orders: 'Ordini',
      sales: 'Vendite',
      previous_month_sales: 'Fatturato mese precedente',
    },
    labels: {
      sales_volume: 'Volume vendite:',
      all: 'Tutti',
      click_to_sort: 'Clicca per ordinare',
      no_data: 'Nessun dato',
    },
    toasts: {
      failed_to_load_data: 'Caricamento dati non riuscito',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Nome',
      sales_manager: 'Responsabile vendite',
      orders: 'Ordini',
      sales: 'Vendite',
      days_live: 'Giorni attivi',
      early_performance: 'Performance iniziale',
    },
    labels: {
      click_to_sort: 'Clicca per ordinare',
      no_data: 'Nessun dato',
      only_with_early_performance: 'Solo con performance iniziale: ',
      early_performance_yes: '✔️ Sì',
      early_performance_no: '✗ No',
    },
    toasts: {
      failed_to_load_data: 'Caricamento dati non riuscito',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Livelli di vendita',
      payments_ratio: 'Rapporto pagamenti',
    },
    dataset_labels: {
      negative: 'Negativo ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Buono ({{values}})',
      excellent: 'Eccellente ({{values}})',
    },

    companies_preview_modal: {
      title: 'Anteprima ristoranti',
      table_columns: {
        name: 'Nome',
        sales_manager: 'Responsabile vendite',
        orders: 'Ordini',
        sales: 'Vendite',
        total_payments: 'Pagamenti totali',
        payments_ratio: 'Rapporto pagamenti',
      },
      labels: {
        close: 'Chiudi',
        click_to_sort: 'Clicca per ordinare',
        no_data: 'Nessun dato',
      },
    },
    toasts: {
      failed_to_load_data: 'Caricamento dati non riuscito',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Attivo',
      no_orders: 'Nessun ordine',
      no_conversion: 'Nessuna conversione',
    },
    toasts: {
      failed_to_load_data: 'Caricamento dati non riuscito',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Tipo di fatturazione',
        options: {
          [BillingTypeOptions.Subscription]: 'Abbonamento',
          [BillingTypeOptions.Manual]: 'Altro',
        },
      },
      high_risk_only: {
        label: 'Solo clienti ad alto rischio',
      },
    },
    fields: {
      name: 'Nome',
      live_from: 'Attivo dal',
      billing_mode: {
        title: 'Fonte fatturazione',
        options: {
          [BillingMode.Stripe]: 'Metodo di pagamento',
          [BillingMode.InternalInvoicing]: 'Vendite',
        },
      },
      trial_ends_at: 'Fine prova',
      last_failed_invoice_amount: 'Importo ultima fattura non riuscita',
      failed_payments_count: 'Numero pagamenti falliti',
    },
    tags: {
      is_high_billing_risk_customer: 'Alto rischio di fatturazione',
    },
    toasts: {
      failed_to_load_data: 'Caricamento dati non riuscito',
    },
  },
};
